import descriptionTextSvg from './description_text.svg';
import ticketValueTextSvg from './ticket_value_text.svg';
import './PlaqueContent.css';

/** decription_text (154:32729) + ticket_value_text (154:32730) — SVG exports. */
export function PlaqueContent() {
  return (
    <>
      <img
        className="tickets-plaque__description"
        src={descriptionTextSvg}
        alt="Заработано"
        draggable={false}
      />
      <img
        className="tickets-plaque__value"
        src={ticketValueTextSvg}
        alt=""
        draggable={false}
        aria-hidden
      />
    </>
  );
}
